import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("g", {
      clipPath: "url(#IconFavoritesOff24a)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m12 3.509 1.653 4.202a3.131 3.131 0 0 0 2.649 1.975l4.51.382-3.558 3.221a3.14 3.14 0 0 0-.954 3.019l1.054 4.673-3.658-2.362a3.125 3.125 0 0 0-3.392 0L6.646 20.98 7.7 16.308a3.14 3.14 0 0 0-.954-3.019l-3.558-3.221 4.51-.382a3.133 3.133 0 0 0 2.649-1.975L12 3.509ZM4.856 22.136h.002-.002ZM10.95.718c.377-.957 1.725-.957 2.102 0l2.464 6.26c.157.402.528.679.956.715l6.492.55c.986.083 1.397 1.31.662 1.976l-5.029 4.553a1.14 1.14 0 0 0-.346 1.095l1.522 6.742c.224.992-.862 1.757-1.713 1.207L12.61 20.3c-.372-.24-.85-.24-1.222 0L5.94 23.817c-.851.55-1.937-.215-1.713-1.207l1.522-6.742a1.14 1.14 0 0 0-.346-1.095L.375 10.219c-.735-.665-.324-1.893.662-1.976l6.492-.55a1.13 1.13 0 0 0 .956-.715L10.95.718Z",
        fill: "currentColor"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "IconFavoritesOff24a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      })
    })]
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconFavoritesOff24 = createIcon(IconComponent);